exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a {\n  text-decoration: underline;\n  color: #0079c1;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/workflows/content-renderer/document-link-viewer/document-link-viewer.component.scss
// module id = 725
// module chunks = 1 2